import { combineReducers } from 'redux';
import loading from './loading';
import input from './input';
import data from './data';
import song from './song';
import pagination from './pagination'
import query from './query'
import toast from './toast';
import block from './block';

export const rootReducer = combineReducers({
    loading,
    input,
    data,
    song,
    pagination,
    query,
    toast,
    block,
});

export type RootState = ReturnType<typeof rootReducer>;

export * from './loading';
export * from './input';
export * from './data';
export * from './song';
export * from './pagination';
export * from './query';
export * from './toast';
export * from './block';


export default rootReducer;